<template>
  <section class="generic">
    <h1>Ensuring Access for Everyone</h1>
    <p>
      Making it easy to explore and enjoy the world of wine means empowering
      people with disabilities to access our expert selections and resources.
      Every page on our website features strong contrasting color along with
      properly and thoughtfully labeled images. The entire site is keyboard
      navigation friendly and functions at a high zoom level. Additionally, we
      have the best customer service team in the business, who go above and
      beyond to ensure that every Wine Access member has an incredible
      experience.
    </p>
    <div class="callout">
      <h4>
        We strive to provide the best possible experience and test with tools
        including:
      </h4>
      <ul>
        <li>
          <strong>Assistive technology testing:</strong>
          Apple VoiceOver, NonVisual Desktop Access (NVDA), Google ChromeVox and
          High Contrast Chrome extension
        </li>
        <li>
          <strong>Accessibility auditing:</strong>
          Google Lighthouse and axe DevTools
        </li>
        <li>
          <strong>Input testing:</strong>
          Mouse, keyboard and touch.
        </li>
      </ul>
      <p>
        We take every measure to ensure our Lighthouse accessibility score
        remains greater than 90% while we work towards our goal of 100%
        accessibility across all pages of Wine Access. Through human interaction
        testing, the tools above, and our partnership with leading accessibility
        compliance company,
        <a href="https://www.levelaccess.com/" target="_blank">Level Access</a>,
        we work continually to identify and address accessibility issues as
        quickly as possible.
      </p>
      <h4>For the best experience, please keep your technology up to date:</h4>
      <ul>
        <li>Use the latest version of your web browser.</li>
        <li>Use the latest version of your assistive technology.</li>
      </ul>
      <h4>Need assistance?</h4>
      <p>
        Please call customer service at <CustomerServicePhoneLink /> if you have
        disabilities and need assistance.
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Accessibility',
}
</script>
